import { defineQuery } from 'next-sanity'

export const dayNurseriesFields = `
  _id,
  _type,
  title,
  displaydiv,
  displayid,
  displaycount,
  apiKey,
  reviewName
`

export const DAY_NURSERIES_QUERY = defineQuery(/* groq */ `
  *[_type == "day-nurseries"][0]{
    ${dayNurseriesFields}
  }
`)
